import { type ComponentType } from 'react'
import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  productsViewAccessControl,
  productsViewItemAnomalyAccessControl,
  productsViewMissingCodesAccessControl,
  productsViewLowPriceAlertsAccessControl,
  aiProductCreatorAccessControl,
} from '../access-control/viewAccess.configuration'
import { productsSearchAccessControl } from '../access-control/searchAccess.configuration'

// @hygen:inject page-import
const ProductsViewPage = lazy(() => import('../pages/view/ProductsViewPage'))
const ProductsSearchPage = lazy(() => import('../pages/search/ProductsSearchPage'))
const ProductsEditImagesPage = lazy(() => import('../pages/images/ProductsEditImagesPage'))
const ItemAnomalyReportsPage = lazy(() => import('../pages/item-anomaly/ItemAnomalyReportsPage'))
const ProductsMissingCodesPage = lazy(
  () => import('../pages/missing-codes/ProductsMissingCodesPage')
)
const ForcemarksMissingCodesDetailsPage = lazy(
  () => import('../pages/missing-codes/ForcemarksMissingCodesDetailsPage')
)
const LowPriceAlertPage = lazy(() => import('../pages/low-price-alert/LowPriceAlertPage'))
const LowPriceAlertDetailsPage = lazy(
  () => import('../pages/low-price-alert/LowPriceAlertDetailsPage')
)
const AiProductCreatorPage = lazy(() => import('../pages/ai-product-creator/AiProductCreatorPage'))

export const productsRouter = (
  <DomainRoute route="products">
    <DashSwitch>
      <DomainRoute
        route="products-view"
        component={ProductsViewPage as ComponentType<any>}
        accessControl={productsViewAccessControl}
      />

      <DomainRoute
        route="products-edit-images"
        component={ProductsEditImagesPage as ComponentType<any>}
        accessControl={productsViewAccessControl}
      />

      <DomainRoute
        exact
        route="products-search"
        component={ProductsSearchPage}
        accessControl={productsSearchAccessControl}
        scopePicker={{
          titles: ['productsDomain.breadcrumbs.root'],
        }}
      />

      <DomainRoute
        exact
        route="item-anomaly-reports"
        tool="item-anomaly-reports-dashboard-tool"
        component={ItemAnomalyReportsPage}
        accessControl={productsViewItemAnomalyAccessControl}
      />

      <DomainRoute
        exact
        route="products-missing-codes"
        tool="missing-codes-dashboard-tool"
        component={ProductsMissingCodesPage}
        accessControl={productsViewMissingCodesAccessControl}
      />

      <DomainRoute
        exact
        route="products-missing-codes-details"
        tool="missing-codes-dashboard-tool"
        component={ForcemarksMissingCodesDetailsPage}
        accessControl={productsViewMissingCodesAccessControl}
      />

      <DomainRoute
        exact
        route="products-low-price-alerts"
        component={LowPriceAlertPage}
        accessControl={productsViewLowPriceAlertsAccessControl}
      />

      <DomainRoute
        exact
        route="products-low-price-alert-details"
        component={LowPriceAlertDetailsPage as ComponentType<any>}
        accessControl={productsViewLowPriceAlertsAccessControl}
      />
      <DomainRoute
        exact
        route="products-ai-product-creator"
        component={AiProductCreatorPage}
        accessControl={aiProductCreatorAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
